import Axios from "axios";
import { url } from "../../global";

const fetchRack = (filter) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'RACK',
            payload: Axios.get(`${url}/rack`, {
                params: {
                    page: filter.page,
                    perpage: filter.perpage,
                    keyword: filter.keyword,
                    ordering: filter.ordering
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

const saveRack = (data) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SAVE_RACK',
            payload: Axios.post(`${url}/rack`, {
                code: data.code,
                name: data.name,
                available: data.available
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

const getRack = (id) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'GET_RACK',
            payload: Axios.get(`${url}/rack/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

const updateRack = (id, data) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_RACK',
            payload: Axios.put(`${url}/rack/${id}`, {
                code: data.code,
                name: data.name,
                available: data.available
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}


const deleteRack = (id) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'DELETE_RACK',
            payload: Axios.delete(`${url}/rack/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

export { fetchRack, saveRack, getRack, updateRack, deleteRack };